import type { PbxSettingsLocale } from './en'

export const pbxSettingsTeIn = {
  loading: 'PBX సెట్టింగ్‌లు లోడ్ అవుతున్నాయి...',
  invalidPbx: {
    title: 'చెల్లని PBX',
    description:
      'PBX సెట్టింగ్‌లను సవరించడానికి సరైన PBX ID అవసరం. దయచేసి డ్యాష్‌బోర్డ్ నుండి PBXని ఎంచుకోండి.',
  },
  loadError: {
    title: 'PBX సెట్టింగ్‌లను లోడ్ చేయలేకపోయాము',
    description: 'దయచేసి మళ్లీ ప్రయత్నించండి.',
  },
  partialLoadWarning: {
    title: 'కొన్ని డేటా లోడ్ కాలేదు',
    unknownError: 'తెలియని లోపం',
    labels: {
      providerGateways: 'ప్రొవైడర్ గేట్‌వేలు',
      serverGroups: 'సర్వర్ గ్రూపులు',
      phoneNumbers: 'ఫోన్ నంబర్లు',
      virtualFaxes: 'వర్చువల్ ఫ్యాక్స్‌లు',
      alert911Options: '911 ఎంపికలు',
    },
  },
  actions: {
    update: 'అప్‌డేట్',
  },
  common: {
    loading: 'లోడ్ అవుతోంది...',
    select: 'ఎంచుకోండి',
  },
  sections: {
    core: {
      title: 'PBX సెట్టింగ్‌లు',
    },
    advanced: {
      title: 'అధునాతన PBX సెట్టింగ్‌లు',
    },
    system: {
      title: 'సిస్టమ్ సెట్టింగ్‌లు',
    },
  },
  placeholders: {
    selectFromList: 'జాబితా నుండి ఎంచుకోండి...',
    selectServerGroup: 'సర్వర్ గ్రూప్ ఎంచుకోండి',
    selectTimeZone: 'టైమ్ జోన్ ఎంచుకోండి',
    selectExtensionDigits: 'ఎక్స్‌టెన్షన్ అంకెలు ఎంచుకోండి',
    selectCodec: 'కోడెక్ ఎంచుకోండి',
  },
  fields: {
    pbxDisplayName: {
      label: 'PBX డిస్‌ప్లే పేరు',
    },
    company: {
      label: 'కంపెనీ',
    },
    providerGateway: {
      label: 'ప్రొవైడర్ గేట్‌వే',
    },
    emergencyProviderGateway: {
      label: 'అత్యవసర ప్రొవైడర్ గేట్‌వే',
    },
    internationalProviderGateway: {
      label: 'అంతర్జాతీయ ప్రొవైడర్ గేట్‌వే',
    },
    active: {
      label: 'సక్రియం',
    },
    smsSenderName: {
      label: 'SMS ప్రేక్షక పేరు',
      copyFromCompany: 'కంపెనీ నుండి కాపీ చేయండి',
      helperText:
        'SMS ఆప్ట్-అవుట్ ప్రత్యుత్తరాలలో మీ కస్టమర్లకు చూపబడుతుంది, ఉదా. "{{name}}: మీరు విజయవంతంగా అన్‌సబ్‌స్క్రైబ్ చేసారు." ఇది లొకేషన్‌కు సంబంధించినది — కంపెనీ పేరుకు భిన్నంగా ఉంటే ఇక్కడ సవరించండి.',
      divergenceHint:
        'కంపెనీ పేరు "{{companyName}}"కి భిన్నంగా ఉంది — బహుళ-లొకేషన్ కస్టమర్లకు ఇది సాధారణం.',
    },
    serverGroup: {
      label: 'సర్వర్ గ్రూప్',
    },
    advanced: {
      maximum_allowed_channels: 'గరిష్ట ఛానెల్స్',
      maximum_lines_in: 'ఇన్‌బౌండ్ ఛానెల్స్',
      maximum_lines_out: 'ప్రతి ఎక్స్‌టెన్షన్‌కు ఛానెల్స్',
      call_log_retention_period_in_months: 'కాల్ చరిత్ర (నెలల్లో)',
    },
    industry: {
      label: 'ఇండస్ట్రీ',
    },
    ehr: {
      label: 'EHR',
      helperText: 'రిపోర్టింగ్ కోసం మాత్రమే, ఫంక్షనాలిటీపై ప్రభావం లేదు',
    },
    defaultEmergencyAlert: {
      label: 'డిఫాల్ట్ అత్యవసర అలర్ట్',
    },
    defaultTimeZone: {
      label: 'డిఫాల్ట్ టైమ్ జోన్',
      britishColumbia: 'పసిఫిక్ సమయం - బ్రిటిష్ కొలంబియా (PCT)',
    },
    callParkTimeout: {
      label: 'కాల్ పార్క్ టైమ్‌అవుట్',
    },
    extensionDigits: {
      label: 'ఎక్స్‌టెన్షన్ అంకెలు',
    },
    defaultAreaCode: {
      label: 'డిఫాల్ట్ ఏరియా కోడ్',
    },
    defaultCallerId: {
      label: 'డిఫాల్ట్ కాలర్ ID',
    },
    defaultFaxNumber: {
      label: 'డిఫాల్ట్ ఫ్యాక్స్ నంబర్',
    },
    defaultVirtualFax: {
      label: 'డిఫాల్ట్ వర్చువల్ ఫ్యాక్స్',
    },
    preferredCodec: {
      label: 'ఇష్టమైన కోడెక్',
    },
    checkboxes: {
      enable_inbound_recording: 'ఇన్‌బౌండ్ కాల్ రికార్డింగ్',
      enable_outbound_recording: 'ఆుట్‌బౌండ్ కాల్ రికార్డింగ్',
      enable_internal_recording: 'అంతర్గత కాల్ రికార్డింగ్',
      international: 'అంతర్జాతీయ',
      enable_vm_transcription: 'వాయిస్‌మెయిల్ ట్రాన్స్‌క్రిప్షన్',
      schedules_v2: 'షెడ్యూల్ V2',
      enable_agent_statuses: 'కాల్ సెంటర్',
      enable_call_analytics: 'Mango AI',
      is_grove: 'Grove',
    },
  },
  companySelect: {
    placeholder: 'కంపెనీని ఎంచుకోండి',
    ariaLabel: 'కంపెనీ సెలెక్టర్',
    searchPlaceholder: 'కంపెనీలను వెతకండి...',
    empty: {
      loading: 'కంపెనీలు లోడ్ అవుతున్నాయి...',
      noResults: 'కంపెనీలు కనుగొనబడలేదు',
      typeToSearch: 'కంపెనీలను వెతకడానికి టైప్ చేయండి',
    },
  },
  phoneSelect: {
    placeholder: 'జాబితా నుండి ఎంచుకోండి...',
    ariaLabel: 'ఫోన్ నంబర్ సెలెక్టర్',
    searchPlaceholder: 'ఫోన్ నంబర్లను వెతకండి...',
    empty: {
      loading: 'ఫోన్ నంబర్లు లోడ్ అవుతున్నాయి...',
      noResults: 'ఫోన్ నంబర్లు కనుగొనబడలేదు',
      noData: 'ఫోన్ నంబర్లు అందుబాటులో లేవు',
    },
  },
  toast: {
    validationError: 'ధృవీకరణ లోపం',
    timezoneChanged: {
      title: 'టైమ్ జోన్ మార్చబడింది',
      description:
        'మీరు PBX టైమ్ జోన్ మార్చారు. దయచేసి మీ షెడ్యూల్‌లను కూడా అప్డేట్ చేయండి.',
    },
    noChanges: 'సేవ్ చేయడానికి మార్పులు లేవు',
    saveSuccess: 'PBX సెట్టింగ్‌లు అప్‌డేట్ అయ్యాయి',
    saveError: {
      title: 'అప్‌డేట్ విఫలమైంది',
      description: 'PBX సెట్టింగ్‌లను అప్‌డేట్ చేయడంలో సమస్య వచ్చింది.',
    },
  },
  callParkConfirm: {
    title: 'కాల్ పార్క్ టైమ్‌అవుట్ నిర్ధారించండి',
    description:
      'కాలర్‌లను 10 నిమిషాలకు మించి పార్కింగ్ లాట్‌లో ఉంచాలనుకుంటున్నారా?',
    cancel: 'టైమ్‌అవుట్ రీసెట్ చేయండి',
    confirm: 'కొనసాగించు',
  },
  rebuildAndReboot: {
    title: 'PBX సెట్టింగ్‌లు అప్‌డేట్ అయ్యాయి',
    description:
      'పరికరాలు పునర్నిర్మించబడి రీబూట్ అయ్యే వరకు కొన్ని PBX సెట్టింగ్‌లు పరికరాలపై ప్రభావం చూపకపోవచ్చు.',
    cancel: 'ఇప్పుడు కాదు',
    confirm: 'పరికరాలను పునర్నిర్మించి రీబూట్ చేయండి',
    toast: {
      successTitle: 'పునర్నిర్మాణం మరియు రీబూట్ ప్రారంభమైంది',
      successDescription: 'అన్ని పరికరాలు పునర్నిర్మించబడి రీబూట్ అవుతున్నాయి.',
      errorTitle: 'పునర్నిర్మాణం మరియు రీబూట్ విఫలమైంది',
      errorDescription:
        'పరికరాలను పునర్నిర్మించి రీబూట్ చేయడంలో సమస్య ఏర్పడింది.',
    },
  },
  validation: {
    pbxDisplayNameRequired: 'దయచేసి PBX డిస్‌ప్లే పేరును నమోదు చేయండి.',
    companyRequired: 'దయచేసి కంపెనీని ఎంచుకోండి.',
    smsSenderNameRequired: 'దయచేసి SMS ప్రేక్షక పేరును నమోదు చేయండి.',
    serverGroupRequired: 'దయచేసి సర్వర్ గ్రూప్‌ను ఎంచుకోండి.',
    primaryOutboundGatewayRequired:
      'దయచేసి ప్రాథమిక ఔట్‌బౌండ్ గేట్‌వేను ఎంచుకోండి.',
    primaryInternationalGatewayRequired:
      'దయచేసి ప్రాథమిక అంతర్జాతీయ గేట్‌వేను ఎంచుకోండి.',
    emergencyGatewayRequired: 'దయచేసి అత్యవసర గేట్‌వేను ఎంచుకోండి.',
    industryRequired: 'దయచేసి ఇండస్ట్రీని ఎంచుకోండి.',
    maxChannelsRequired: 'దయచేసి గరిష్ట ఛానెల్స్ నమోదు చేయండి.',
    inboundChannelsRequired: 'దయచేసి ఇన్‌బౌండ్ ఛానెల్స్ నమోదు చేయండి.',
    perExtensionChannelsRequired:
      'దయచేసి ప్రతి ఎక్స్‌టెన్షన్‌కు ఛానెల్స్ నమోదు చేయండి.',
    callHistoryRequired: 'దయచేసి కాల్ చరిత్ర నమోదు చేయండి.',
    numericFieldRange: '{{field}} {{min}} మరియు {{max}} మధ్య ఉండాలి.',
    numericFieldMin: 'కనిష్టం {{min}}.',
    numericFieldMax: 'గరిష్టం {{max}}.',
    defaultTimeZoneRequired: 'దయచేసి డిఫాల్ట్ టైమ్ జోన్ ఎంచుకోండి.',
    callParkTimeoutRange:
      'దయచేసి కాల్ పార్క్ టైమ్‌అవుట్‌ను {{min}}-{{max}} మధ్య నమోదు చేయండి (సిఫార్సు: {{recommended}}).',
    callParkTimeoutMax: 'కాల్ పార్క్ టైమ్‌అవుట్ {{max}} సెకన్లను మించకూడదు.',
    extensionDigitsRequired: 'దయచేసి ఎక్స్‌టెన్షన్ అంకెలను నమోదు చేయండి.',
    extensionDigitsInvalid: 'ఎక్స్‌టెన్షన్ అంకెలు 3, 4 లేదా 5 కావాలి.',
    defaultAreaCodeRequired: 'దయచేసి డిఫాల్ట్ ఏరియా కోడ్ నమోదు చేయండి.',
    defaultAreaCodeDigits: 'డిఫాల్ట్ ఏరియా కోడ్ 3 అంకెల సంఖ్య కావాలి.',
    defaultAreaCodeRange: 'డిఫాల్ట్ ఏరియా కోడ్ 200 మరియు 998 మధ్య ఉండాలి.',
    defaultAreaCodeDisallowed:
      'ఏరియా కోడ్ {{code}} డిఫాల్ట్ ఏరియా కోడ్‌కు అనుమతించబడదు.',
    defaultCallerIdRequired: 'దయచేసి డిఫాల్ట్ కాలర్ ID ఎంచుకోండి.',
    defaultFaxNumberRequired: 'దయచేసి డిఫాల్ట్ ఫ్యాక్స్ నంబర్ ఎంచుకోండి.',
    defaultVirtualFaxRequired: 'దయచేసి డిఫాల్ట్ వర్చువల్ ఫ్యాక్స్ ఎంచుకోండి.',
    preferredCodecRequired: 'దయచేసి ఇష్టమైన కోడెక్ ఎంచుకోండి.',
  },
} satisfies PbxSettingsLocale
